module.exports = __webpack_public_path__ + "img/birthEngraving.2a4346d.jpg";